import {
  prepareRequest
} from './request'
import SettingsManager from '../managers/settings'

export const fetchCompetitions = () => {
  const {
    lang
  } = SettingsManager.settings

  const request = prepareRequest({
    method: 'GET',
    url: 'competitions/competition',
    query: {
      locale: lang
    }
  })

  return request()
}

export const fetchCompetition = (id) => {
  const {
    lang
  } = SettingsManager.settings

  const request = prepareRequest({
    method: 'GET',
    url: `competitions/competition/${id}/leaderboard`,
    query: {
      locale: lang
    }
  })

  return request()
}
